import { put, call } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';

import { SocialCommunityPAppRepository } from '../../../../repositories';
import { fetchComments, addComment, deleteComment } from '../reducers';
import { digestResponse } from '../../../middlewares/response';

export function* watchFetchComments(action: ReturnType<typeof fetchComments>) {
  const { type, payload } = action;
  const { postId, channelId, ...restParams } = payload;

  const response: AxiosResponse = yield call(() =>
    SocialCommunityPAppRepository.findAllComments(postId, restParams, channelId)
  );

  yield put(digestResponse(response, type));
}

export function* watchAddComment(action: ReturnType<typeof addComment>) {
  const { type, payload } = action;
  const { postId, channelId, ...restBody } = payload;

  const response: AxiosResponse = yield call(() =>
    SocialCommunityPAppRepository.createComment(postId, restBody, channelId)
  );

  yield put(digestResponse(response, type));
}

export function* watchDeleteComment(action: ReturnType<typeof deleteComment>) {
  const { type, payload } = action;
  const { postId, commentId, channelId } = payload;

  const response: AxiosResponse = yield call(() =>
    SocialCommunityPAppRepository.removeComment({ postId, commentId }, channelId)
  );

  yield put(digestResponse(response, type));
}
